'use es6';

import { createAction } from 'redux-actions';
import { getAllDashboards } from '../api/dashboardApi';
import actionTypes from '../constants/actionTypes';
const dashboardsRequested = createAction(actionTypes.GET_DASHBOARDS_REQUESTED);
const dashboardsSucceeded = createAction(actionTypes.GET_DASHBOARDS_SUCCEEDED);
const dashboardsFailed = createAction(actionTypes.GET_DASHBOARDS_FAILED);
export const getDashboards = () => {
  return dispatch => {
    dispatch(dashboardsRequested());
    return getAllDashboards().then(dashboards => {
      dispatch(dashboardsSucceeded(dashboards));
      return dashboards;
    }).catch(exception => dispatch(dashboardsFailed(exception)));
  };
};